import { CSSProperties } from 'react';

import { CurrenciesColor, DEFAULT_COLOR } from '../components/common/currencies/constants';
import variables from '../styles/variables.module.scss';

const ALLOWED_CURRENCY_COLORS = [variables.Color_White500, variables.Color_LightGray500, variables.Color_Gray500];

export function parseHexColor(color: string): number[] | null {
  const rgbMatch = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/);

  if (!rgbMatch) {
    return null;
  }

  const hexMatch = rgbMatch[1];
  const rgbMatches = hexMatch.match(new RegExp('.'.repeat(hexMatch.length / 3), 'g'));

  if (!rgbMatches) {
    return null;
  }

  return rgbMatches.map((hex) => parseInt(hex.padStart(2, hex), 16));
}

export function getColorRelativeLuminance(hexColor: string): number | null {
  const parsed = parseHexColor(hexColor);

  if (!parsed) {
    return null;
  }

  const colorValues = parsed.map((value) => {
    const scaled = value / 255;

    return scaled <= 0.03928 ? scaled / 12.92 : ((scaled + 0.055) / 1.055) ** 2.4;
  });

  return colorValues[0] * 0.2126 + colorValues[1] * 0.7152 + colorValues[2] * 0.0722;
}

export function getContrastValue(hexColor1: string, hexColor2: string): number | null {
  const luminance1 = getColorRelativeLuminance(hexColor1);
  const luminance2 = getColorRelativeLuminance(hexColor2);

  if (luminance1 === null || luminance2 === null) {
    return null;
  }

  return (Math.max(luminance1, luminance2) + 0.05) / (Math.min(luminance1, luminance2) + 0.05);
}

export function getCurrencyStyle(currency: string): CSSProperties {
  const backgroundColor = CurrenciesColor[currency] ?? DEFAULT_COLOR;
  const style: CSSProperties = { backgroundColor };

  let maxContrastValue = -Infinity;
  let maxContrastValueColor: string | null = null;

  ALLOWED_CURRENCY_COLORS.forEach((color) => {
    const contrastValue = getContrastValue(color, backgroundColor);

    if (contrastValue !== null && contrastValue > maxContrastValue) {
      maxContrastValue = contrastValue;
      maxContrastValueColor = color;
    }
  });

  if (maxContrastValueColor) {
    style.color = maxContrastValueColor;
  }

  return style;
}
